import React from "react";
import { Reveal } from "../components/Reveal";
import EnquireDialog from "../components/EnquireDialog";
import { useLang } from "../contexts/LanguageContext";
import SEO, { organizationSchema } from "../components/SEO";

export default function Products() {
  const { t } = useLang();
  const items = t("products_page.items") || [];
  const imgs = [
    "/images/gallery/lsp-13.jpg", "/images/gallery/lsp-14.jpg",
    "/images/gallery/lsp-15.jpg", "/images/gallery/lsp-16.jpg",
    "/images/gallery/lsp-17.jpg", "/images/gallery/lsp-18.jpg",
    "/images/gallery/lsp-19.jpg", "/images/gallery/lsp-20.jpg",
  ];

  return (
    <div>
      <SEO metaKey="products" pathname="/products" schemas={[organizationSchema()]} />

      <section className="relative isolate bg-forest text-white">
        <div className="absolute inset-0 z-0">
          <img src="/images/gallery/lsp-13.jpg" alt="" className="w-full h-full object-cover" loading="eager" />
          <div className="absolute inset-0 bg-black/55 md:bg-forest/75" />
        </div>
        <div className="relative z-10 max-w-[1400px] mx-auto px-5 sm:px-8 lg:px-12 py-28 lg:py-40 min-h-[70vh] flex flex-col justify-end">
          <Reveal>
            <div className="editorial-divider mb-6 max-w-xs" style={{ color: "#E3A839" }}>{t("products_page.eyebrow")}</div>
            <h1 className="font-serif font-light text-5xl sm:text-6xl lg:text-8xl leading-[0.96] max-w-5xl">
              {t("products_page.h1a")} <br /> <span className="italic text-mustard">{t("products_page.h1b")}</span>
            </h1>
            <p className="mt-8 max-w-2xl text-lg text-white/85 leading-relaxed">{t("products_page.intro")}</p>
          </Reveal>
        </div>
      </section>

      <section className="bg-ivory">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8 lg:px-12 py-16 lg:py-24 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {items.map((p, i) => (
            <Reveal key={p.name} delay={(i % 4) * 0.06}>
              <div data-testid={`product-card-${i}`} className="group rounded-xl overflow-hidden border border-dust bg-kraft/20 h-full flex flex-col">
                <div className="relative h-56 overflow-hidden">
                  <img src={imgs[i]} alt={p.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" loading="lazy" />
                  <span className="absolute top-4 left-4 px-3 py-1 text-[10px] tracking-[0.25em] uppercase rounded-full bg-ivory/90 text-forest">{p.tag}</span>
                </div>
                <div className="p-6 flex-1 flex flex-col">
                  <h3 className="font-serif text-xl text-forest">{p.name}</h3>
                  <p className="mt-2 text-[14px] text-ink/70 leading-relaxed flex-1">{p.desc}</p>
                  <EnquireDialog productName={p.name} testId={`enquire-${i}`}
                    trigger={
                      <button data-testid={`enquire-btn-${i}`} className="mt-5 btn-pill btn-terra w-full justify-center text-[13px] py-2.5">
                        {t("common.enquire_now")}
                      </button>
                    }
                  />
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-forest text-ivory">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8 lg:px-12 py-20 lg:py-28 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
          <div>
            <div className="editorial-divider mb-3" style={{ color: "#E3A839" }}>{t("products_page.bulk_eyebrow")}</div>
            <h3 className="font-serif text-3xl lg:text-5xl max-w-2xl">{t("products_page.bulk_title")}</h3>
          </div>
          <a href="tel:+919938056120" data-testid="products-bulk-call-btn" className="btn-pill bg-mustard text-forest hover:bg-mustard/90 whitespace-nowrap">
            {t("common.call_us")}
          </a>
        </div>
      </section>
    </div>
  );
}
